'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _envs = require('../configs/envs');

var environmentConstant = _interopRequireWildcard(_envs);

var _environment = require('../lib/environment');

var _environment2 = _interopRequireDefault(_environment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * @since 2016-08-14 13:48
 * @author vivaxy
 */

var MOCK_API_ROOT = '/api';

exports.default = function (url) {
    var requestPath = '';
    var host = location.host;
    if (url.startsWith('http')) {
        return url;
    }
    switch (_environment2.default) {
        case environmentConstant.DEVELOPMENT:
            requestPath = '' + MOCK_API_ROOT + url + '.json';
            break;
        case environmentConstant.BETA:
            requestPath = '//act.51ping.com' + url;
            break;
        case environmentConstant.PPE:
            if (host.indexOf('act.dianping') > -1) {
                requestPath = '//act-ppe.dianping.com' + url;
            } else {
                requestPath = '//act-ppe.dper.com' + url;
            }
            break;
        case environmentConstant.PRODUCTION:
            if (host.indexOf('act.dianping') > -1) {
                requestPath = '//act.dianping.com' + url;
            } else {
                requestPath = '//act.dper.com' + url;
            }
            break;
        default:
            break;
    }
    return requestPath;
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/cmp-prototype-lib/lib/requestPath.js
// module id = 234
// module chunks = 0